import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { Box } from "@mui/material";

const FinancialDialog = ({ open, onClose, reset }) => {
    const { t } = useTranslation();
    const [selected, setSelected] = useState([]);

    const { control } = useForm();

    const options = [
        {
            value: "public-housing",
            label: t("My child lives in public housing (for example, Garfield, Lodi, or Hackensack)."),
        },
        {
            value: "section-8",
            label: t("My child lives in Section 8 housing (for example, Garfield, Lodi, or Hackensack)."),
        },
        {
            value: "tanf",
            label: t("My child’s parent or guardian receives SNAP (food stamps) or TANF benefits."),
        },
        {
            value: "free-lunch",
            label: t("My child already qualifies for free or reduced-price lunch at their current public school."),
        },
    ];

    const handleConfirm = () => {
        if (selected.length > 0) {
            onClose();
        }
    };

    const handleCancel = () => {
        setSelected([]);
        reset("isLowIncome");
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={() => { }}
            disableEscapeKeyDown
            maxWidth="sm"
            TransitionProps={{ onEntering: () => setSelected([]) }}
        >
            <DialogTitle>{t("Weighted Lottery for Economically Disadvantaged Students")}</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" gutterBottom>
                    {t(
                        "Bergen ASCS uses a weighted lottery to make sure economically disadvantaged students have a fair chance."
                    )}
                    <br />
                    {t(
                        "If your child qualifies, they will receive two tickets in the lottery instead of one."
                    )}
                </Typography>

                <Controller
                    name="languageOptions"
                    control={control}
                    defaultValue={[]}
                    rules={{
                        validate: (value) =>
                            value?.length > 0 || t("Please select at least one option."),
                    }}
                    render={({ field, fieldState }) => (
                        <FormGroup>
                            {options.map((opt) => (
                                <Box key={opt.value} sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={field.value?.includes(opt.value) || false}
                                                onChange={(e) => {
                                                    let newSelected;
                                                    if (e.target.checked) {
                                                        newSelected = [...(field.value || []), opt.value];
                                                    } else {
                                                        newSelected = (field.value || []).filter((v) => v !== opt.value);
                                                    }
                                                    field.onChange(newSelected);
                                                    setSelected(newSelected);
                                                }}
                                            />
                                        }
                                        label={opt.label}
                                    />
                                </Box>
                            ))}
                            {fieldState.error && (
                                <p style={{ color: "red", fontSize: "0.875rem" }}>
                                    {fieldState.error.message}
                                </p>
                            )}
                        </FormGroup>
                    )}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>{t("Child Not Eligible")}</Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    disabled={selected.length === 0}
                >
                    {t("Confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FinancialDialog;
